import Navigo from 'navigo';

import Card from './Components/Card/Card';
import Button from './Components/Button/Button';
import Headline from './Components/Headline/Headline';
import FeatureCard from './Components/Card/FeatureCard';
import Faq from './Components/Faq/Faq';
import ShowcaseCard from './Components/Card/ShowcaseCard';
import Map from './Components/Map/Map';
import BlogList from './Components/Blog/BlogList';
import Hotel from './Components/Hotel/Hotel';
import Booking from './Components/Booking/Booking';
import Slider from './Components/Slider/HotelRoomImages';
import HotelRooms from './Components/Slider/HotelRooms';
import Navigation from './Components/Navigation/Navigation';
import NavigationAccordion from './Components/Navigation/NavigationAccordion';
import HeroSlider from './Components/Slider/HeroSlider';

const router = new Navigo('/');

router.on('/', () => {});

Navigation();
NavigationAccordion();
Card();
Button();
Headline();
FeatureCard();
Faq();
ShowcaseCard();
Map();
BlogList();
Hotel();
HotelRooms();
Slider();
Booking();
HeroSlider();

router.notFound(() => true);

router.resolve();
